import { Link } from '@mui/material';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import ListItemText from '@mui/material/ListItemText';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { fAPIDate } from 'src/utils/format-time';
import { fCurrencyRupees } from 'src/utils/format-number';

import Label from 'src/components/label';

import { IIssuedChequeListItem, getIssuedChequeStatusColor } from 'src/types/issued-cheque';

type Props = {
  row: IIssuedChequeListItem;
};

export default function IssuedChequeTableRow({ row }: Props) {
  const { _id, bank, chequeNumber, chequeDate, amountInCents, type, payee, status } = row;

  return (
    <Link
      component={RouterLink}
      href={paths.dashboard.issuedCheque.view(_id)}
      sx={{ textDecoration: 'none', color: 'inherit', display: 'contents' }}
    >
      <TableRow hover>
        <TableCell>
          <ListItemText
            primary={chequeNumber}
            secondary={bank}
            primaryTypographyProps={{ typography: 'body2' }}
            secondaryTypographyProps={{
              component: 'span',
              color: 'text.disabled',
              typography: 'caption',
            }}
          />
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }}>{payee}</TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }}>{fAPIDate(chequeDate)}</TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
          {fCurrencyRupees(amountInCents)}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }}>{type}</TableCell>

        <TableCell>
          <Label variant="soft" color={getIssuedChequeStatusColor(status)}>
            {status}
          </Label>
        </TableCell>

        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <Button variant="soft" color="primary">
            View More
          </Button>
        </TableCell>
      </TableRow>
    </Link>
  );
}
